import { render, staticRenderFns } from "./PDFThumbnail.vue?vue&type=template&id=0af5c01c&scoped=true&"
import script from "./PDFThumbnail.vue?vue&type=script&lang=js&"
export * from "./PDFThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./PDFThumbnail.vue?vue&type=style&index=0&id=0af5c01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5c01c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
